import { useEffect, useRef, useState } from "react";
import { Star, ChevronLeft, ChevronRight } from "lucide-react";
import "../Styles/Review.css";
import api from '../Component/Api';

const Reviews = () => {
  const reviews = [
    {
      name: "David",
      role: "Barber",
      image: "https://i.pinimg.com/736x/fd/85/df/fd85df845b7bd441ebfb7dbd786fa36f.jpg",
      text: "I don't have to search for my Instagram or give someone my number anymore. I just tell them to tap my wrist.",
    },
    {
      name: "Sarah",
      role: "Business Owner",
      image: "https://media.istockphoto.com/id/2263144233/photo/office-portrait-and-woman-with-arms-crossed-smile-or-financial-analyst-with-career-growth-or.jpg?s=612x612&w=0&k=20&c=euyKSTyzSqJb4-l3klKx6d5e2lHSB1T0r4oqNcTw9Rw=",
      text: "It's so simple. I wear it every day and when someone asks about my business, I just tell them to tap it.",
    },
    {
      name: "Michael",
      role: "Creator",
      image: "https://i.pinimg.com/1200x/d5/60/cb/d560cb16591a9690f2488c77890cde80.jpg",
      text: "Everything I want people to see is in one place. My socials, website and contact details are just one tap away.",
    },
    {
      name: "Jessica",
      role: "Makeup Artist",
      image: "https://i.pinimg.com/1200x/ae/75/6a/ae756a2e0dad9f4ff384f64b2e44a7c1.jpg",
      text: "I used to give people my Instagram username. Now I just tell them to tap my wrist. It's much easier.",
    },
    {
      name: "Daniel",
      role: "DJ",
      image: "https://i.pinimg.com/736x/d4/c9/6c/d4c96c24bdf68d013f367898c153629a.jpg",
      text: "The best part is that I don't have to think about it. I put the band on and my business is always with me.",
    },
    {
      name: "Mitch",
      role: "Gym Instructor",
      image: "https://media.istockphoto.com/id/2215301644/photo/focused-gym-training-session-with-mid-adult-black-female-and-personal-trainer.jpg?s=612x612&w=0&k=20&c=RqsNz5eJR2pgoJFkBZXFPEFBtQ2eYO24sCAe8fEildU=",
      text: "It feels like carrying my whole business with me without actually carrying anything. People love how easy it is.",
    },
  ];

  const carouselRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [visible, setVisible] = useState(false);
   const [totalTaps, setTotalTaps] = useState(0);


    useEffect(() => {
    const getTotalTaps = async () => {
      try {
        const response = await api.get('/total-lifetime-scans'
        );

        if (response.data.success) {
          setTotalTaps(response.data.totalScans);
        }
      } catch (error) {
        console.error("Failed to fetch total taps:", error);
      }
    };

    getTotalTaps();
   
  }, []);
  /*
   * Reveal section when it enters viewport
   */
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      {
        threshold: 0,
      }
    );

    if (carouselRef.current) {
      observer.observe(carouselRef.current);
    }

    return () => observer.disconnect();
  }, []);

  /*
   * Detect active card while scrolling
   */
  const handleScroll = () => {
    const container = carouselRef.current;

    if (!container) return;

    const cards = container.querySelectorAll(".review-card");

    if (!cards.length) return;

    let closestIndex = 0;
    let closestDistance = Infinity;

    cards.forEach((card, index) => {
      const distance = Math.abs(
        card.offsetLeft -
          container.scrollLeft -
          20
      );

      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    setActiveIndex(closestIndex);
  };

  /*
   * Scroll to a specific review
   */
  const goToReview = (index) => {
    const container = carouselRef.current;
    const cards = container?.querySelectorAll(".review-card");

    if (!container || !cards?.[index]) return;

    container.scrollTo({
      left: cards[index].offsetLeft - 20,
      behavior: "smooth",
    });

    setActiveIndex(index);
  };

  const nextReview = () => {
    const next = Math.min(
      activeIndex + 1,
      reviews.length - 1
    );

    goToReview(next);
  };

  const previousReview = () => {
    const previous = Math.max(
      activeIndex - 1,
      0
    );

    goToReview(previous);
  };

  return (
    <section
      className={`reviews-section ${
        visible ? "reviews-visible" : ""
      }`}
    >

      {/* HEADER */}

      <div className="reviews-header">

        <p className="reviews-eyebrow">
          REAL PEOPLE. REAL BUSINESSES.
        </p>

        <h2>
          People are already
          <br />
          <span>wearing it.</span>
        </h2>

        <p className="reviews-intro">
          See why business owners and creators are
          carrying their business with them.
        </p>

      </div>


      {/* TAP COUNTER */}

      <div className="reviews-stat">

        <div className="tap-number">
  {(12480 + totalTaps).toLocaleString()}+
        </div>

        <div className="tap-label">
          Taps through ClusterClear
        </div>

      </div>


      {/* REVIEW CAROUSEL */}

      <div
        ref={carouselRef}
        className="reviews-carousel"
        onScroll={handleScroll}
      >

        {reviews.map((review, index) => (

          <article
            key={review.name}
            className="review-card"
          >

            {/* IMAGE */}

            <div className="review-image-wrapper">

              <img
                src={review.image}
                alt={`${review.name} wearing ClusterClear`}
                className="review-image"
              />

              <div className="review-number">
                {String(index + 1).padStart(2, "0")}
              </div>

            </div>


            {/* CONTENT */}

            <div className="review-content">

              <div className="review-stars">
                {[1, 2, 3, 4, 5].map((star) => (
                  <Star
                    key={star}
                    size={14}
                    fill="currentColor"
                    strokeWidth={0}
                  />
                ))}
              </div>

              <p className="review-text">
                "{review.text}"
              </p>

              <div className="review-person">

                <strong>
                  {review.name}
                </strong>

                <span>
                  {review.role}
                </span>

              </div>

            </div>

          </article>

        ))}

      </div>


      {/* CONTROLS */}

      <div className="reviews-controls">

        <button
          className="review-arrow"
          onClick={previousReview}
          disabled={activeIndex === 0}
          aria-label="Previous review"
        >
          <ChevronLeft size={18} />
        </button>


        {/* Progress */}

        <div className="review-progress">

          {reviews.map((_, index) => (

            <button
              key={index}
              className={`progress-dot ${
                activeIndex === index
                  ? "active"
                  : ""
              }`}
              onClick={() => goToReview(index)}
              aria-label={`Go to review ${index + 1}`}
            />

          ))}

        </div>


        <button
          className="review-arrow"
          onClick={nextReview}
          disabled={
            activeIndex === reviews.length - 1
          }
          aria-label="Next review"
        >
          <ChevronRight size={18} />
        </button>

      </div>


      {/* COUNTER */}

      <div className="review-counter">

        <span>
          {String(activeIndex + 1).padStart(2, "0")}
        </span>

        <div className="counter-line" />

        <span>
          {String(reviews.length).padStart(2, "0")}
        </span>

      </div>

    </section>
  );
};

export default Reviews;